/* Rodízio do topo com os mais vendidos (shesssite-entrada e shesssite-destaque). */
(function(){
  if (window.__lsHero) return; window.__lsHero = 1;
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function iniciar(h){
    if (h.__ok) return; h.__ok = 1;
    var s = [].slice.call(h.querySelectorAll('.ls-hero__slide'));
    var p = [].slice.call(h.querySelectorAll('.ls-hero__ponto'));
    if (s.length < 2) return;
    var i = 0, t = null, pausa = false, seg = (parseInt(h.getAttribute('data-segundos'), 10) || 5) * 1000;
    function ir(n){
      s[i].classList.remove('is-on'); s[i].inert = true; if (p[i]) p[i].setAttribute('aria-current', 'false');
      i = (n + s.length) % s.length;
      s[i].classList.add('is-on'); s[i].inert = false; if (p[i]) p[i].setAttribute('aria-current', 'true');
    }
    function agenda(){ clearTimeout(t); if (reduz || pausa) return; t = setTimeout(function(){ ir(i + 1); agenda(); }, seg); }
    p.forEach(function(b, k){ b.addEventListener('click', function(){ ir(k); agenda(); }); });
    h.addEventListener('mouseenter', function(){ pausa = true; clearTimeout(t); });
    h.addEventListener('mouseleave', function(){ pausa = false; agenda(); });
    h.addEventListener('focusin', function(){ pausa = true; clearTimeout(t); });
    h.addEventListener('focusout', function(){ pausa = false; agenda(); });
    var x0 = null;
    h.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', function(e){
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { ir(dx < 0 ? i + 1 : i - 1); agenda(); }
    }, { passive: true });
    agenda();
  }
  function todos(){ document.querySelectorAll('[data-ls-hero]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();
